import { connect } from 'react-redux';
import { logoutAction, changePasswordAction } from '@smorder/logic';
import Drawer from './drawer';


const mapStateToProps = state => ({
  filters: state.reports.filters,
  userName: state.authentication.user.userName,
});

const mapDispatchToProps = dispatch => ({
  changePassword: (oldPassword, newPassword, confirmPassword) => dispatch(changePasswordAction.INIT(
    { oldPassword, newPassword, confirmPassword },
  )),
  logout: () => dispatch(logoutAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Drawer);
